import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'

import axios from "axios";
import $ from 'jquery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearchMinus, faSearchPlus,
    faArrowUp, faArrowDown, faArrowLeft, faArrowRight,
    faSearch, faAngleUp, faAngleDown, faTimes } from '@fortawesome/free-solid-svg-icons';
    
import './nlp/nlp.css';
import './nlp/hierarchy-select.min.css';
import './nlp/bbox.css';
import bbox from './nlp/bbox_adl.js';
import frm from './formAux.js'



/*
https://labeling-datasets.s3.ap-south-1.amazonaws.com/output/Home-Appliance-Job-3/manifests/output/output.manifest
s3://labeling-datasets/output/kitti-bounding-box-audit/manifests/output/output.manifest
*/
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }

function clone(o) { return JSON.parse(JSON.stringify(o)); }

function valueIn( v, list ) {
    return list.indexOf(v) != -1;
}



function taskNav()
{
    if( !window.GlobalVars.taskList ) return;
    var nav = $('<div class="task-spacer"></div><div class="task-nav"><i class="fa fa-step-backward first"></i><i class="fa fa-backward prev"></i><span class="task-pos"></span><i class="fa fa-forward next"></i><i class="fa fa-step-forward last"></i></div>');
    if( $('.top-nav').html() == '')$('.top-nav').append( $('<button>') );
    $('.top-nav').append( nav );
    var tlist = window.GlobalVars.taskList;
    var len = tlist.list.length;
    var pos = tlist.idx+1;
    $('.task-pos').text( 'Task '+pos+' of '+len );  // modifytask to Task 22/12 mani
    nav.find('I').on('click', function(){
        var npos = 0;
        if( $(this).hasClass('prev') ) npos = pos-2;
        else if( $(this).hasClass('next') ) npos = pos;
        else if( $(this).hasClass('last') ) npos = len-1;
        if( npos < 0 ) npos = 0;
        var nextFile = null;
        // if( tlist.list[npos] ) nextFile = tlist.list[npos].fileId;
        if( tlist.list[npos] ) nextFile = tlist.list[npos];
        if( nextFile )
        {
            var params = window.getParams();
            params.fileId = nextFile;
            window.GlobalVars.PDFFileId = nextFile;
            tlist.idx = npos;
            window.saveSession( function(){
                window.goPage( window.getPage(1), params ) 
            } );
            return;
        }
        window.saveSession();
        window.goPage(backPage)
    })
}


var backPage = 'nlpBrowse';
var submitted = false;

var resumeLaterTid = null;

function ViewerBBox(prop) {
    window.bbox = bbox;
    
    useEffect( function(a){
        console.log('dest', window.descriptor)
        if( window.GlobalVars.PDFRole ) backPage = 'nlpJobs';
        // $('#maincolumn').hide();
        window.setNavActive(backPage);
        let params = window.getParams();
        var fileId = params.fileId;
        // var fileId = window.GlobalVars.PDFFileId;
        // var myId = window.GlobalVars.userId || window.GlobalVars.workerId;
        var myId = window.GlobalVars.userId;
        var myEmail = window.GlobalVars.userEmail;

        function resumeLater() {
            console.log( 'resumeLater', bbox.updating() )
            clearTimeout( resumeLaterTid )
            if( !bbox.updating() ) {
                setTimeout( function(){window.goPage(backPage);}, 500 );
            }
            else resumeLaterTid = setTimeout( resumeLater, 500 );
        }
        $('#resumeLater').on('click', function(){
            if( deepLinkResult() ) return;
            resumeLater();
        });                                                         

        function deepLinkResult() {
            if( window.GlobalVars.deepLinkReturnURL ) {
                var a = $('<a target="_top">').attr('href', window.GlobalVars.deepLinkReturnURL );
                $(document.body).append(a);
                a[0].click();
                return true;
            } 
            return false;
        }

        function submitAnnotations( obj )
        {
            if( submitted ) return;
            submitted = true;

            console.log( 'SUBMIT', obj )
            window.post( 'save_annotation', {
                fileId:fileId,
                myId:myId,
                annotations:obj,
                target:'final',
                role:window.GlobalVars.PDFRole
            }, function(res){
                if( window.GlobalVars.taskList )
                {
                    var tlist = window.GlobalVars.taskList;
                    // if( tlist.list[tlist.idx+1] ) tlist.next = tlist.list[tlist.idx+1].fileId;
                    if( tlist.list[tlist.idx+1] ) tlist.next = tlist.list[tlist.idx+1];
                    else tlist.next = 'next';
                    window.saveSession();
                }

                window.goPage(backPage)
                console.log( 'submited' );
            });
        }

        function updateAnnotations( obj )
        {
            console.log( 'UPDATE', obj );
            window.post( 'save_annotation', {
                fileId:fileId,
                myId:myId,
                myEmail:myEmail,
                annotations:obj,
                target:'tmp',
                role:window.GlobalVars.PDFRole
            }, function(res){
                console.log( 'updated' );
            });
        }
        var claimWait = false;
        function claimCallback(descriptor) {
            if (claimWait) return;
            claimWait = true;
            window.post('claim_task', { fileId: fileId }, function (res) {
                console.log('CLAIM', res.data)
                if (!res.data) {
                    return frm.myAlert('Claim Error', "You cant't clame this task")
                }
                if (descriptor.task_orig_state > 1 && descriptor.task_orig_state != 7 && !descriptor.disableQC) {
                    descriptor.reviewMode = 1;
                }
                descriptor.blockEdit = false;
                descriptor.fixButtons(descriptor);
                claimWait = false;
            });
        }
        
        function releaseCallback(descriptor) {
            frm.myAlert('Release Task', "By releasing the task, any temporary annotations you've made will be lost. Are you sure?", "Ok", release, "Cancel");
            function release() {
                window.post('release_task', { fileId: fileId, myId: myId }, function (res) {
                    console.log('RELEASE', res.data, descriptor)
                    if (!res.data) {
                        return frm.myAlert('Release Error', "You cant't release this task")
                    }
                    if (descriptor.task_orig_state > 1) {
                        descriptor.reviewMode = false;
                    }
                    descriptor.blockEdit = true;
                    descriptor.task_can_claim = true;
                    descriptor.fixButtons(descriptor);
                    window.goPage(backPage);
                })
            }
        }

        // var modal = $('<div id="myModal" class="modal fade" role="dialog" style="z-index: 100000">').html('<div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close myclose" data-dismiss="modal">&times;</button><h4 class="modal-title">Modal Header</h4></div><div class="modal-body"><p>Some text in the modal.</p></div><div class="modal-footer"><button type="button" id="modal-close" class="btn btn-secondary" data-dismiss="modal">Close</button><button type="button" id="modal-close2" class="btn btn-secondary" data-dismiss="modal">Close</button><button type="button" id="modal-close3" class="btn btn-secondary" data-dismiss="modal">Close</button></div></div></div>');
        // $(document.body).prepend(modal);
        console.log( 'LOADFILE', {fileId:fileId,myId:myId} )

        setTimeout( taskNav, 1 );
        window.post( 'load_file', {fileId:fileId,myId:myId}, function(res){
            console.log( 'LOAD_FILE', res.data );
            var file = res.data;
            $('#pageTitle').html('Project: <span>'+file.projectName+'</span>');
            var fdesc = file.descriptor;
            var descriptor = {title:file.name};
            var fdata = {};

            function yn( v ) { return v ? "Yes" : "No" };

            var url = file.adlUrl || file.signedUrl;
            if( url.match(/localhost/) ) url = url.replace( /localhost/, document.location.hostname );
            console.log( 'URL', url )
            console.log( 'file', clone(file) )
            console.log( 'descriptor', fdesc )
            fdata.image_attrs = [];
            if( fdesc.attributes && fdesc.attributes.length ) fdata.image_attrs = clone(fdesc.attributes)
            fdata.colorize_attributes = {};
            function setColor( attr, label, color ) {
                if( !fdata.colorize_attributes[attr] ) fdata.colorize_attributes[attr] = {};
                fdata.colorize_attributes[attr][label] = color;
            }
            for( var kl in fdesc.labelAttributes ) {
                var l = fdesc.labelAttributes[kl];
                l.label = kl;
                l.optional = yn( l.optional )
                var opt = l.options.split(',').map( o => o.trim() );
                l.options = opt.map( o => o.split(':')[0] );
                var colors = opt.map( o => o.split(':')[1] || null );
                for( var i = 0 ; i < l.options.length ; i++ ) {
                    if( colors[i] ) setColor( kl, l.options[i], colors[i] )
                }
                if( l.image ) fdata.image_attrs.push( l );
                delete l.image;
            }
            fdata.object_labels = [];
            function walk( root, o, level ) {
                if( !level ) level = 0;
                for( var k in o ) {
                    var nobj = {};
                    nobj.label = k;
                    // nobj.type = o[k].keypoint ? "keypoint" : "box";
                    if (window.GlobalVars.PDFProjectType === 'Segmentation') {
                        nobj.type = 'polygon';
                    } else {
                        nobj.type = o[k].keypoint ? "keypoint" : "box";

                    }
                    if( level ) nobj.optional = yn(o[k].optional);
                    nobj.color = o[k].color || null;
                    var alist = [];
                    for( var kl in fdesc.labelAttributes ) {
                        if( o[k][kl] ) alist.push(fdesc.labelAttributes[kl]);
                    }
                    if( o[k].linkto ) nobj.linkto = o[k].linkto;
                    nobj.attrs = alist;
                    if( o[k].sublabels ) {
                        nobj.sub_labels = [];
                        walk( nobj.sub_labels, o[k].sublabels, level+1 )
                    }
                    root.push( nobj );
                }
            }
            walk( fdata.object_labels, fdesc.labels )
            descriptor.descriptor = fdata;
            descriptor.reviewMode = window.GlobalVars.PDFRole == 'nlp_qc';
            descriptor.reviewMayRequestAdjustment = file.userEmail > '' && fdesc.qcMayRequestAdjustment;
            descriptor.enableOutsideImage = fdesc.enableOutsideImage;
            descriptor.enableOccluded = fdesc.enableOccluded;

            // descriptor.submit = submitAnnotations;
            // descriptor.update = updateAnnotations;
            descriptor.scene = {url:url, image_attrs:{}};
            descriptor.canDecline = true;
            var deskMeta = descriptor;
            if( !deskMeta.metadata ) deskMeta.metadata = {};
            if( file.name ) deskMeta.metadata.File = file.name;
            if( window.hasPriv( 'admin', 'c_admin', 'c_super') ) deskMeta.metadata.TaskId = file.fileId;
            if( file.metadata ) for( var m in file.metadata ) deskMeta.metadata[m] = file.metadata[m];
            if( fdesc.metadata ) for( var m in fdesc.metadata ) deskMeta.metadata[m] = fdesc.metadata[m];
            var loadfrom = file.myAnnotations || file.annotations;
            if( loadfrom )
            {
                ['boxes', 'image_attrs', 'review','elapsedTime','jobStart','attributes'].forEach( l => {
                    if( loadfrom[l] ) descriptor.scene[l] = loadfrom[l];
                });
            }
            if( file.messages && file.messages.length ) descriptor.messages = file.messages;
            descriptor.reviewMode = file.state == 3;
            descriptor.reviewMayRequestAdjustment = file.userEmail > '' && fdesc.qcMayRequestAdjustment;
            descriptor.task_can_decline = true;
            // descriptor.task_can_claim = (descriptor.fullListMode || false) && (file.state == 0 || file.state==2);
            descriptor.task_can_claim = (
                ( valueIn(file.state, [0,2,4,5,7,8]) && window.hasPriv('admin', 'c_admin','c_super')) || 
                (file.state==0  && window.hasPriv('nlp_an')) ||
                (file.state==2  && window.hasPriv('nlp_qc'))
            );
            descriptor.task_can_release = (fdesc.fullListMode || false);
            if( descriptor.task_can_release ) {
                if( file.userEmail == window.GlobalVars.userEmail && file.state > 1 ) descriptor.task_can_release = false;
                else if( file.qcEmail == window.GlobalVars.userEmail && file.state < 2 ) descriptor.task_can_release = false;
            }
            descriptor.task_orig_state = file.state;
            descriptor.task_role = valueIn(file.state, [0, 1, 6, 7]) || descriptor.disableQC ? 'Annotator' : 'Reviewer';
            
            try {
                var role = window.GlobalVars.PDFRole || 'nlp_an';
                var emailcheck = file.state >= 2 && file.state <= 3 ? 'qcEmail' : 'userEmail';
                var currEmail = file[emailcheck][file[emailcheck].length - 1]
                descriptor.blockEdit = currEmail != window.GlobalVars.userEmail;
                if ([0, 1, 2, 3, 6].indexOf(file.state) == -1) descriptor.blockEdit = true;
            }
            catch (e) { }

            
            descriptor.submit = submitAnnotations;
            descriptor.update = updateAnnotations;
            descriptor.claimCallback = claimCallback;
            descriptor.releaseCallback = releaseCallback;

            // console.log( 'LOADFROM', clone(loadfrom) );
            console.log( 'DESC', clone(descriptor) );
            var tid = window.setTimeout( function(){bbox.preload(descriptor);}, 100 );
        });
    },[]);

    return (
        <div className="allcontent">
            <div className="bbox-metadata media-metadata"></div>
            <main id="maincolumn" role="main" className="maincontent hidden">
                <div className="leftcol scroll-thin icols">
                    <div id="toolbox" className="toolbox centered">
                            {/* hide remove button */}
                            {/* {window.GlobalVars.PDFProjectType == "Key Point" &&(
                            <div id="removeborder" className="toolbox-button">
                                <div><i className="fa fa-square-o" aria-hidden="true"></i></div>
                                <div>Remove Border</div>
                            </div>
                            )}  
                            */}
                        <div id="zoomin" className="toolbox-button">
                        <div><i className="fa fa-search-plus" aria-hidden="true"></i></div> 
                            {/* <div><img class="" src="imgs/p_zoom-in.svg" /></div>mani */}
                            <div>Zoom In</div>
                        </div>
                        <div id="zoomout" className="toolbox-button">
                            <div><i className="fa fa-search-minus" aria-hidden="true"></i></div> 
                            {/* <div><img class="" src="imgs/p_zoom-out.svg" /></div>mani */}
                            <div>Zoom out</div>
                        </div>
                        <div id="panmode" className="toolbox-button">
                            <div><i className="fa fa-arrows" aria-hidden="true"></i></div>  
                            {/* <div><img class="" src="imgs/p_zoom-out-map.svg" /></div>mani */}
                            <div>Pan</div>
                        </div>
                        <div id="brushmode" className="toolbox-button segmentation-mode">
                            <div><i className="fa fa-paint-brush" aria-hidden="true"></i></div>
                            <div>Brush</div>
                        </div>
                        <div id="polymode" className="toolbox-button segmentation-mode">
                        <div><i className="fa fa-eraser" aria-hidden="true"></i></div>
                            {/* <div><svg data-v-320ec513="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="draw-polygon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="svg-inline--fa fa-draw-polygon fa-w-14"><path data-v-320ec513="" fill="currentColor" d="M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z" className=""></path></svg></div> */}
                            <div>Polygon</div>
                        </div>
                        <div id="opacitymode" className="toolbox-button segmentation-mode">
                            <div><i className="fa fa-adjust"></i></div>
                            <div>Opacity</div>
                        </div>
                        <div id="brightmode" className="toolbox-button segmentation-mode">
                            <div><i className="fa fa-sun-o"></i></div>
                            <div>Brighness</div>
                        </div>
                        {/* <div id="boxmode" className="toolbox-button box-mode">
                            <div><i className="fa fa-object-group" aria-hidden="true"></i></div>
                            <div>Box</div>
                        </div> */}
                        {window.GlobalVars.PDFProjectType === "Pose Estimation" && (
                          <div id="enableRotation" className="toolbox-button">
                            <div><i className="fa fa-refresh" aria-hidden="true"></i></div>
                             <div>Rotate</div>
                             </div>
                        )}
                        <div id="boxmode" className="toolbox-button box-mode">
                            <div>
                                <i 
                                    className={window.GlobalVars.PDFProjectType === "Key Point" ? "fa fa-mouse-pointer" : "fa fa-object-group"} 
                                    aria-hidden="true"
                                ></i>
                            </div>
                            <div>
                                {window.GlobalVars.PDFProjectType === "Key Point" ? "Key Point" : "Box"}
                            </div>
                        </div>
                        
                        <div id="allsubs" className="toolbox-button box-mode">
                            <div><i className="fa fa-sitemap" aria-hidden="true"></i></div> 
                            <div>All Subs</div>
                        </div>
                        
                        {window.GlobalVars.PDFProjectType !== "Segmentation" && (
                            <>
                                <div id="btnundo" className="toolbox-button">
                                    <div><i className="fa fa-undo" aria-hidden="true"></i></div> 
                                    {/* <div><img class="" src="imgs/p_undo.svg" /></div>mani */}
                                    <div>Undo</div>
                                </div>
                                <div id="btnredo" className="toolbox-button">
                                    <div><i className="fa fa-repeat" aria-hidden="true"></i></div> 
                                    {/* <div><img class="" src="imgs/p_redo.svg" /></div>mani */}
                                    <div>Redo</div>
                                </div>
                            </>
                        )}
                        {window.GlobalVars.PDFProjectType === "Segmentation" && (
                            <div>
                                <div id="btnundo" className="toolbox-button">
                                    <div><i className="fa fa-undo" aria-hidden="true"></i></div>
                                    <div>Undo</div>
                                </div>
                                <div id="btnredo" className="toolbox-button">
                                    <div><i className="fa fa-repeat" aria-hidden="true"></i></div>
                                    <div>Redo</div>
                                </div>
                            </div>
                        )}

                        {/* dhinesh burshtool is work but select from annotation list so disabled */}
                        {/* {window.GlobalVars.PDFProjectType !== "Segmentation" && ( */}
                        <div id="erasemode" className="toolbox-button segmentation-mode">
                            <div><i className="fa fa-eraser" aria-hidden="true"></i></div>
                            <div>Erase</div>
                        </div>
                         {/* )} */}
                        <div id="btndelete" className="toolbox-button">
                            <div><i className="fa fa-remove" aria-hidden="true"></i></div>
                            {/* <div><img class="" src="imgs/p_delete.svg" /></div>mani */}
                            <div>Delete</div>
                        </div>
                    </div></div>
                <div className="middlecol ccol-10 imgdisplay icols">
                    <div id="imageoverlay" className="overlay centered">
                        <img id="imgpreview" width="100%" alt="Image preview..." />
                    </div>

                </div>
                <div className="ccol-2 rightcol ctrlpanel icols">


                    <div id="controlpanel" className="controlpanel mt-2">
                        <div id="messages" className="file-messages"></div>
                        <div className="mt-2" id="submit">
                            <div id="reviewer-fields" className="hidden-obj">
                                <select className="mmdb-select mmd-form iselect" id="reviewer_rate">
                                    <option value="">Are the Annotations Ok?</option>
                                    <option value="Ok">Annotations are OK</option>
                                    <option value="Rejected">Reject Annotations</option>
                                    <option id="optadjust" value="Adjust">Request Adjustments</option>
                                </select>
                                <textarea id="reviewer_notes" className="inote-text mt-2" placeholder="Reviewer Notes"></textarea>
                            </div>
                            <textarea id="annotator_notes" className="inote-text mt-2" placeholder="Annotator Notes"></textarea>
                        </div>
                        <div className="mt-2 video-toolbar-content" id="submitBox">
                            <button id="submitButton" type="submit" className="mt-2 btn btn-primary bbox-submit">Submit</button>
                            <button id="resumeLater" type="submit" className="mt-2 btn btn-secondary bbox-resume">Save & Exit</button>
                        </div>
                        <div id="boxlist"></div>
                        <div className="mt-2" id="image_attrs"></div>

                        <div className="mt-2">
                        </div>
                    </div>
                    
                </div>
            </main>
        </div>
    )
}

export default ViewerBBox
